const projects = {
	bookmark_organizer: {
		name: 'Bookmark Organizer',
		img: 'screenshot_bookmark-organizer.png',
		role: 'Design Lead',
		desc: 'Reorganize, search, filter, save and access your browser bookmarks without having to go through the poor user experience of built-in bookmark managers. Created by a team of four as the final capstone project for the Thinkful Engineering Immersion program.',
		tech: 'HTML5, CSS3, JavaScript, React, Node, Express, PostgreSQL',
		liveUrl: 'https://bookmark-organizer.now.sh',
		clientGit: 'https://github.com/thinkful-ei-heron/Group5-Capstone3-Client',
		serverGit: 'https://github.com/thinkful-ei-heron/Group5-Capstone3-Server'
	}
}

module.exports = { projects }